// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TaxDefinitionEditController = function ($rootScope, $scope, $location, $routeParams, TaxDefinition, gettextCatalog, gettext) {

    $scope.taxCategoryCodes = Object.freeze({
        "E": gettextCatalog.getString(gettext("E (Exempt from tax)")),
        "G": gettextCatalog.getString(gettext("G (Free export item, tax not charged)")),
        "Z": gettextCatalog.getString(gettext("Z (Zero rated goods)")),
    });

    if ($routeParams.taxDefinitionId) {
        $scope.taxDefinition = TaxDefinition.get({ id: $routeParams.taxDefinitionId }, function (){
            $scope.taxDefinition.CategoryCode = $scope.taxDefinition.CategoryCode || "E";  
        });
    } else {
        $scope.taxDefinition = new TaxDefinition();
        $scope.taxDefinition.PrimaryCategory = $routeParams.category;
        $scope.taxDefinition.CategoryCode = "E";
    }

    function finish() {
        $location.path("/settings/taxdefinitions");
    }

    $scope.isReadonly = function () {
        return $scope.taxDefinition.Predefined;
    }

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;
        if ($routeParams.taxDefinitionId)
            $scope.taxDefinition.$update({ id: $routeParams.taxDefinitionId }, finish);
        else
            $scope.taxDefinition.$save({}, finish);
    };

    $scope.back = finish;
    return;

    // ReSharper disable JsUnreachableCode
    // noinspection UnreachableCodeJS
    gettext("Vat");
    gettext("Untaxed");
    gettext("ReverseCharge");
    gettext("Special");

    gettext("VatNote");
    gettext("VatZeroNote");
    gettext("MultiPurposePrepaidCardNote");
    gettext("TaxFreeExportNote");
    gettext("ReverseChargeNote");
    gettext("ChargebackFeeNote");
    gettext("IntraGroupNote");
    gettext("IntraEuSupplyNote");
};
TaxDefinitionEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', 'TaxDefinition', 'gettextCatalog', 'gettext'];
